import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { PublicHttpClientService } from "./http-client.service";

@Injectable()
export class PublicVideoVerificationSessionsService {
  constructor(private publicHttp: PublicHttpClientService) {}

  public getMeetingInfo(token: string): Observable<any> {
    return this.publicHttp
      .get(`/api/video_verification_sessions/${token}`)
      .pipe(tap((_) => console.log("PublicVideoVerificationSessionsService.getMeetingInfo: Ok.")));
  }

  public updateCallStatus(token: string, started_at: Date | string, ended_at: Date | string): Observable<any> {
    const options = { started_at, ended_at };
    return this.publicHttp
      .put(`/api/video_verification_sessions/${token}/update_call_status`, options)
      .pipe(tap((_) => console.log("PublicVideoVerificationSessionsService.updateCallStatus: Ok.")));
  }

  public scheduleCall(token: string, scheduled_at: Date | string): Observable<any> {
    const options = { scheduled_at };
    return this.publicHttp
      .put(`/api/video_verification_sessions/${token}/schedule_call`, options)
      .pipe(tap((_) => console.log("PublicVideoVerificationSessionsService.scheduleCall: Ok.")));
  }

  public registerAttempt(
    token: string,
    user: "analyst" | "client",
    location: any = { latitude: null, longitude: null },
    answered: boolean = true
  ): Observable<any> {
    const options = { user, location, answered };
    return this.publicHttp
      .put(`/api/video_verification_sessions/${token}/register_attempt`, options)
      .pipe(tap((_) => console.log("PublicVideoVerificationSessionsService.registerAttempt: Ok.")));
  }
}
